import { withChartLayout } from 'components/common';
import NeurologicalInterventions from 'components/features/chart/system-nursing-interventions/neurological-interventions/NeurologicalInterventions';

const NeurologicalInterventionsPage = withChartLayout('Neurological Interventions')(NeurologicalInterventions);
export default NeurologicalInterventionsPage;
